const ClientPluginsHeader = () => {
    return (
        <thead>
            <tr>
                <th style={{ width: '1%' }}></th>
                <th style={{ width: '34%' }}>Plugin</th>
                <th style={{ width: '20%' }}>Version</th>
                <th style={{ width: '20%' }}>Status</th>
                <th style={{ width: '5%' }}></th>
                <th className="text-center" style={{ width: '15%' }}>Options</th>
                <th className="text-center" style={{ width: '5%' }}></th>
            </tr>
        </thead>
    );
};

export default ClientPluginsHeader;